<template>
  <div class="mb-3 d-flex align-items-center" style="gap: 1em">
    <div v-if="$can('toggle concierge advisers status')" class="custom-checkbox-primary">
      <input
        type="hidden"
        name="is_active"
        value="0"
        class="custom-switch-hidden-input"
        style="pointer-events: none"
      />
      <input
        type="checkbox"
        id="is_active"
        name="is_active"
        value="1"
        v-model="statusForm.is_active"
        :disabled="statusForm.processing"
        @change="toggleActiveStatus"
      />
      <label for="is_active" class="font-weight-normal">
        {{ $t('models/conciergeAdvisers.singular') }}&nbsp;
        {{ $t('models/conciergeAdvisers.fields.is_active') }}
      </label>
    </div>
    <div>
      <i v-if="statusForm.processing" class="fa-solid fa-spinner fa-spin"></i>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { useForm } from '@inertiajs/vue3'
import type { ConciergeAdviserScheduleAdviserData } from '~types/concierge-admin'

export default defineComponent({
  props: {
    adviser: {
      type: Object as () => ConciergeAdviserScheduleAdviserData,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    uneditableMessage: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const statusForm = useForm<{ is_active: boolean }>({
      is_active: props.adviser.isActive
    })

    return {
      statusForm
    }
  },
  methods: {
    toggleActiveStatus(): void {
      if (!this.isEditable && this.adviser.isActive) {
        this.$toast.open({
          message: this.uneditableMessage,
          type: 'error',
          duration: 5000,
          dismissible: true
        })
        return
      }

      this.statusForm.patch(
        route('conciergeAdvisers.toggleStatus', {
          teamMemberId: this.adviser.teamMemberId
        })
      )
    }
  }
})
</script>
